function App() {
  return <div className="Effet_Mer-vitrine"></div>;
}

export default App;
